import { InfoIcon } from '../assets/InfoIcon';
import { AlertCircle, CircleCheck } from 'lucide-react';
import { toast, type ExternalToast } from 'sonner';

/**
 * Show an error toast notification
 * @param message - The error message to display
 * @param options - Additional toast options to override defaults
 * @returns Toast ID
 */
export const showError = (message: string, options?: ExternalToast) => {
  return toast.error(message, {
    duration: 4000,
    position: 'top-center',
    icon: <AlertCircle className="text-white" fill="#E11D48" />,
    classNames: {
      content: 'text-muted-foreground ml-2',
    },
    ...options,
  });
};

/**
 * Show a success toast notification
 * @param message - The success message to display
 * @param options - Additional toast options to override defaults
 * @returns Toast ID
 */
export const showSuccess = (message: string, options?: ExternalToast) => {
  return toast.success(message, {
    duration: 3000,
    position: 'top-center',
    icon: <CircleCheck className="text-white" fill="#16A34A" />,
    classNames: {
      content: 'text-muted-foreground ml-2',
    },
    ...options,
  });
};

/**
 * Show an info toast notification
 * @param message - The info message to display
 * @param options - Additional toast options to override defaults
 * @returns Toast ID
 */
export const showInfo = (message: string, options?: ExternalToast) => {
  return toast.info(message, {
    duration: 4000,
    position: 'top-center',
    icon: <InfoIcon />,
    classNames: {
      content: 'text-muted-foreground ml-2',
    },
    ...options,
  });
};
